import { MainApi } from 'api/MainApi'
import Loader from 'components/Loader/Loader'
import { useEffectOnce } from 'hooks/useEffectOnce'
import { useEffect, useState } from 'react'
import { PROGRESS_TYPES } from 'utils/constants'
import { ICleaningZone, IRecordedRoute, IRoute } from 'utils/interfaces'

import RecordedRouteListView from './RecordedRouteListView/RecordedRouteListView'

const RecordedRouteList = () => {
  const [loadingProgress, setLoadingProgress] = useState(PROGRESS_TYPES.IDLE)
  const [recordedRoutes, setRecordedRoutes] = useState<IRecordedRoute[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const PAGE_SIZE = 20

  const fetchData = async (page: number = currentPage, search: string = debouncedSearchQuery) => {
    try {
      const response = await MainApi.fetchRecordedRoutes(page, PAGE_SIZE, search || undefined)
      setRecordedRoutes(response.results)
      setTotalCount(response.count)
    } catch (error) {
      setLoadingProgress(PROGRESS_TYPES.ERROR)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery)
    }, 300)
    return () => clearTimeout(timer)
  }, [searchQuery])

  useEffect(() => {
    if (loadingProgress === PROGRESS_TYPES.SUCCESS) {
      setCurrentPage(1)
      fetchData(1, debouncedSearchQuery)
    }
  }, [debouncedSearchQuery])

  useEffectOnce(() => {
    const initialize = async () => {
      setLoadingProgress(PROGRESS_TYPES.WORK)
      await fetchData()
      setLoadingProgress(PROGRESS_TYPES.SUCCESS)
    }
    initialize()
  })

  const onPageChanged = (page: number) => {
    setCurrentPage(page)
    fetchData(page)
  }

  const onSearchChanged = (search: string) => {
    setSearchQuery(search)
  }

  const stateList = {
    [`${PROGRESS_TYPES.SUCCESS}`]: (
      <RecordedRouteListView
        recordedRoutes={recordedRoutes}
        onRoutesChanged={() => fetchData()}
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={PAGE_SIZE}
        onPageChanged={onPageChanged}
        searchQuery={searchQuery}
        onSearchChanged={onSearchChanged}
      />
    ),
    [`${PROGRESS_TYPES.WORK}`]: <Loader />,
    [`${PROGRESS_TYPES.ERROR}`]: <div>Error</div>,
  }

  return stateList[loadingProgress] || null
}

export default RecordedRouteList
